import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { HttpClient } from '@wix/http-client';
import URI from 'urijs';
import { Wix, window } from '@wix/photography-client-lib';
import { utils } from './utils/utils';
var httpClient = new HttpClient();
export var WixStoreApi = /*#__PURE__*/function () {
  function WixStoreApi(instanceId, _instance, locale, wixApi, protocol) {
    _defineProperty(this, "publishStore", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(instance) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return httpClient.post("https://progallery.wix.com/api/v1/store/publish?isStore=true&instance=" + instance, JSON.stringify({}), {
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
              });
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.log({
                e: _context.t0
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.connectedProvidersCache = null;
    this.galleryDataPromise = null;
    this.instanceId = instanceId;
    this.instance = _instance;
    this.locale = locale;
    this.wixApi = wixApi;
    this.protocol = protocol;
    this.httpClient = new HttpClient({
      withCredentials: true,
      headers: {
        Authorization: _instance
      }
    });
  }
  var _proto = WixStoreApi.prototype;
  _proto.getStoreGalleryData = function getStoreGalleryData(ignoreCache) {
    var _this = this;
    if (ignoreCache === void 0) {
      ignoreCache = false;
    }
    this.getStorePurchasesHistory();
    if (!this.connectedProvidersCache && this.galleryDataPromise) {
      return this.galleryDataPromise;
    } else if (this.connectedProvidersCache && !ignoreCache) {
      this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
    } else {
      this.galleryDataPromise = this.sendRequest('GET', "gallery/" + this.instanceId + "/providers", null).then(function (response) {
        _this.connectedProvidersCache = response;
        return _this.connectedProvidersCache;
      });
    }
    return this.galleryDataPromise;
  };
  _proto.getStorePurchasesHistory = function getStorePurchasesHistory() {
    return this.httpClient.get("" + this.protocol + utils.getBaseUrl() + "/_api/pro-gallery-webapp/v1/purchase", {
      params: {
        instance: this.instance,
        locale: this.locale,
        deviceType: 'desktop',
        cachekiller: new Date().getTime(),
        isStore: true
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };
  _proto.connectProvider = function connectProvider(providerId) {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.sendRequest('POST', "providers/" + providerId + "/connect", null).then(function (result) {
        _this2.getProviders().then(function (providersData) {
          if (providersData && Array.isArray(providersData.providers)) {
            var providersList = providersData.providers;
            var connectedProvider = providersList.find(function (providerData) {
              return providerData.providerId === providerId;
            });
            if (connectedProvider) {
              resolve({
                result: result,
                providers: providersData
              });
            } else {
              reject();
            }
          } else {
            reject();
          }
        });
      });
    });
  };
  _proto.getProviders = function getProviders() {
    return this.sendRequest('GET', 'providers/approved', null).then(function (response) {
      window.providers = response.providers;
      return response;
    });
  };
  _proto.sendRequest = function sendRequest(type, endpoint, data) {
    var url = new URI(this.getUrlPrefix() + endpoint).search({
      instance: this.instance,
      locale: this.locale,
      deviceType: 'desktop',
      cachekiller: new Date().getTime(),
      isStore: true
    });
    return this.httpClient.request({
      method: type,
      url: url.toString(),
      data: data,
      withCredentials: true,
      xsrfCookieName: null,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };
  _proto.getUrlPrefix = function getUrlPrefix() {
    return this.protocol + utils.getBaseUrl() + '/_api/pro-gallery-editor-webapp/v1/';
  };
  _proto.generateUrl = function generateUrl(endpointFile, params) {
    params = params || {};
    var uri = new URI(this.getUrlPrefix() + endpointFile);
    uri.search(params);
    return uri.toString();
  };
  _proto.generateBizMgrArtStoreUrl = function generateBizMgrArtStoreUrl(metasiteId, siteUrl) {
    var EDITOR_X_MANAGE_BASE_URL = 'https://manage.editorx.com';
    var EDITOR_MANAGE_BASE_URL = 'https://www.wix.com';
    var baseUrl = siteUrl.includes('editorx') ? EDITOR_X_MANAGE_BASE_URL : EDITOR_MANAGE_BASE_URL;
    // eslint-disable-next-line new-cap
    var bizMgrUrl = URI(baseUrl).segment('dashboard').segment(metasiteId).segment('art-store').search({
      isEditor: true
    });
    return bizMgrUrl.toString();
  };
  _proto.getDashboardUrl = function getDashboardUrl(options) {
    var _this3 = this;
    return new Promise(function (resolve, reject) {
      var doReject = function doReject(message) {
        console.error(message);
        reject(message);
      };
      _this3.wixApi.Settings.getSiteInfo(function (siteInfo) {
        var siteUrl = siteInfo.url;
        _this3.wixApi.Settings.getDashboardAppUrl(function (url) {
          if (url) {
            var uriDashboardUrl = URI(url);
            var arrSegments = uriDashboardUrl.segment();
            var isValidSegment = Array.isArray(arrSegments) && arrSegments.length;
            if (isValidSegment) {
              var metasiteId = null;
              var isMyAccountIndex = arrSegments.indexOf('my-account');
              var isBizMgrIndex = arrSegments.indexOf('dashboard');
              if (isMyAccountIndex !== -1) {
                metasiteId = arrSegments[isMyAccountIndex + 2]; // format www.wix.com/my-account/sites/[metasite id]/app/[appDefId]
              } else if (isBizMgrIndex !== -1) {
                metasiteId = arrSegments[isBizMgrIndex + 1]; // format www.wix.com/dashboard/[metasite id]
              } else {
                doReject("getDashboardUrl - Invalid dashboard url (unknown): " + url);
              }
              if (metasiteId) {
                var bizMgrUrl = _this3.generateBizMgrArtStoreUrl(metasiteId, siteUrl);
                resolve({
                  url: bizMgrUrl.toString(),
                  title: undefined
                });
              }
            } else {
              doReject("getDashboardUrl - Invalid dashboard url (format): " + url);
            }
          } else {
            doReject("getDashboardUrl - No url");
          }
        });
      });
    });
  };
  _proto.openDashboard = function openDashboard(options) {
    var _this4 = this;
    if (options === void 0) {
      options = {};
    }
    return new Promise(function (resolve, reject) {
      _this4.getDashboardUrl(options).then(function (_ref3) {
        var url = _ref3.url,
          title = _ref3.title;
        _this4.wixApi.Settings.openModal(url, '100%', '100%', title, resolve, !title, {
          overlay: 'rgba(0,0,0,0)',
          background: 'rgba(0,0,0,0)',
          margin: '0px 0px 0px 0px',
          padding: false
        });
      })["catch"](function (message) {
        reject(message);
      });
    });
  };
  _proto.getProviderModalUrl = function getProviderModalUrl(params) {
    if (params === void 0) {
      params = {};
    }
    var queryParams = Object.assign({}, params, {
      isStore: true
    });
    var uri = new URI(this.protocol + "//progallery.wixapps.net/pro-gallery-webapp/provider-modal.html");
    var url = uri.search(queryParams).toString();
    return url;
  };
  _proto.openProviderModal = function openProviderModal(name, connectedProviders, options, containerParams) {
    var _this5 = this;
    if (options === void 0) {
      options = {};
    }
    if (containerParams === void 0) {
      containerParams = {};
    }
    return new Promise(function (resolve, reject) {
      if (name) {
        var providerId = Object.keys(connectedProviders)[0];
        var providerData = connectedProviders[providerId];
        var widgets = providerData.widgets;
        if (widgets[name]) {
          var objAdditionalParams = _this5.getProviderUrlOptions(options);
          var finalParams = Object.assign({
            name: name
          }, objAdditionalParams, containerParams);
          var providerModalUrl = _this5.getProviderModalUrl(finalParams);
          _this5.wixApi.openPopup(providerModalUrl, '100%', '100%', {
            origin: _this5.wixApi.WindowOrigin.FIXED,
            placement: _this5.wixApi.WindowPlacement.CENTER
          }, function () {
            console.log('Provider modal closed', providerId);
          }, _this5.wixApi.Theme.BARE);
          resolve();
        } else {
          reject("Name '" + name + "' does not exist in widgets", providerId);
        }
      } else {
        reject('Name not defined');
      }
    });
  };
  _proto.getProviderUrlOptions = function getProviderUrlOptions(options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      urlParams = _options.urlParams,
      urlPath = _options.urlPath;
    var objAdditionalParams = {
      urlParams: '{}',
      urlPath: '/'
    };
    if (urlParams && typeof urlParams === 'object') {
      var encodedParams = JSON.stringify(urlParams);
      objAdditionalParams.urlParams = encodedParams;
    }
    if (urlPath && typeof urlPath === 'string') {
      objAdditionalParams.urlPath = urlPath;
    }
    return objAdditionalParams;
  };
  return WixStoreApi;
}();
var storeApi = null;
if (typeof window !== 'undefined') {
  storeApi = new WixStoreApi(window.instanceId, window.instance, window.locale, Wix, window.location.protocol);
  window.WixStoreApi = storeApi;
}
export default storeApi;